import { baseUrl } from "../../../boot/index";
import axios from "axios";

// Add Inventory
export const addInventoryInverter = async (formData) => {
  const token = localStorage.getItem("authToken");
  try {
    const response = await axios.post(`${baseUrl}cleaningappfunctions/finance/app/v1/create-inventoryInvertor`, formData, {
      headers: {
        "auth-token": token,
      },
    });
    return response;
  } catch (error) {
    console.log({ error });
    throw error;
  }
};

// update Inventory
export const updateInventoryInverter = async (data) => {
  console.log({ data });
  const ROWID = data.ROWID;
  const token = localStorage.getItem("authToken");
  try {
    const response = await axios.put(`${baseUrl}cleaningappfunctions/finance/app/v1/update-inventoryInvertor/${ROWID}`, data, {
      headers: {
        "auth-token": token,
      },
    });
    return response;
  } catch (error) {
    throw error;
  }
};
// delete Inventory
export const deleteInventoryInverter = async (ROWID) => {
  console.log({ ROWID });
  const token = localStorage.getItem("authToken");
  try {
    const response = await axios.delete(`${baseUrl}cleaningappfunctions/finance/app/v1/delete-inventoryInvertor/${ROWID}`, {
      headers: {
        "auth-token": token,
      },
    });
    return response;
  } catch (error) {
    console.log("Error is - ", error);
    throw error;
  }
};

// total count
export const countInventoryInverter = async (formData) => {
  const token = localStorage.getItem("authToken");
  try {
    const response = await axios.get(`${baseUrl}cleaningappfunctions/finance/app/v1/count-inventoryInvertor`, formData, {
      headers: {
        "auth-token": token,
      },
    });
    return response;
  } catch (error) {
    throw error;
  }
};

// Get Inventory by ID
export const getInventoryInvertorById = async (id) => {
  const token = localStorage.getItem("authToken");
  try {
    const response = await axios.get(`${baseUrl}cleaningappfunctions/finance/app/v1/getbyid-inventoryInvertor/${id}`, {
      headers: {
        "auth-token": token,
      },
    });
    return response;
  } catch (error) {
    throw error;
  }
};
